module.exports = __webpack_public_path__ + "static/media/Vector4.a53ee61f.svg";